(function( $, window, document, undefined) {
    var Video = {
        init: function init(elem) {
            this.$mediaContainer = $( elem );
            this.$videoContainer = $( '.introduction__video' );
            this.active = false;

            this.events();
        },

        events: function events() {
            if (!this.active) {
                this.$videoContainer.on( 'click', this.openVideo.bind(this) );
                this.active = true;
            }
        },

        openVideo: function openVideo(event) {
            this.$videoContainer.addClass('--active');
            this.$videoContainer.find('iframe')[0].src += "&autoplay=1";

            if ( event ) {
                event.preventDefault();
            }

            this.$videoContainer.off('click');
        },
    };

    $.fn.video = function() {
        var videoObj = Object.create( Video );
        return videoObj.init(this);
    };

})( jQuery, window, document );
